const MallColor: ButtonColor & InputColor & TextColor & BoxColor & {} = {
    'button-border-gray': 'rgb(153,153,153)',
    'button-bg-blue': 'rgb(9,168,250)',
    'input-checkbox-mark-gray': 'rgb(241,241,241)',
    'input-checkbox-border-gray': 'rgb(213,213,213)',
    'input-checkbox-bg-blue': 'rgb(9,168,250)',
    'input-text-gray': 'rgb(153,153,153)',
    'input-text-red': 'rgb(255,0,0)',
    'input-bg-white': 'rgb(247, 247, 247)',
    'input-bg-gray': 'rgb(245, 245, 245)',
    'input-border-gray': 'rgb(213,213,213)',
    'input-border-black': 'rgb(153,153,153)',
    'text-font-gray': 'rgb(153,153,153)',
    'text-font-blue': 'rgb(9,168,250)',
    'text-border-blue': 'rgb(9,168,250)',
    'text-chip-bg-blue': 'rgb(230,238,255)',
    'box-bg-gray': 'rgb(104,104,104)',
    'box-bg-white': 'rgb(247, 247, 247)',
};

export default MallColor;

type ButtonColor = {
    'button-border-gray': 'rgb(153,153,153)';
    'button-bg-blue': 'rgb(9,168,250)';
};

type InputColor = {
    'input-text-gray': 'rgb(153,153,153)';
    'input-text-red': 'rgb(255,0,0)';
    'input-border-gray': 'rgb(213,213,213)';
    'input-border-black': 'rgb(153,153,153)';
    'input-bg-white': 'rgb(247, 247, 247)';
    'input-bg-gray': 'rgb(245, 245, 245)';
    'input-checkbox-mark-gray': 'rgb(241,241,241)';
    'input-checkbox-border-gray': 'rgb(213,213,213)';
    'input-checkbox-bg-blue': 'rgb(9,168,250)';
};

type TextColor = {
    'text-font-gray': 'rgb(153,153,153)';
    'text-font-blue': 'rgb(9,168,250)';
    'text-border-blue': 'rgb(9,168,250)';
    'text-chip-bg-blue': 'rgb(230,238,255)';
};

type BoxColor = {
    'box-bg-gray': 'rgb(104,104,104)';
    'box-bg-white': 'rgb(247, 247, 247)';
};
